const SICPO = {
  C007PaginasWeb: 'SICPO/Catalogos/GetPaginasWeb',
  C007PaginaWeb: 'SICPO/Catalogos/GetPaginaWeb',
  C008SeccionesDeLaPaginaWeb: 'SICPO/Catalogos/GetSeccionesDeLaPaginaWeb',
  C008SeccionDeLaPaginaWeb: 'SICPO/Catalogos/GetSeccionDeLaPaginaWeb',
  C006Submenus: 'SICPO/Catalogos/GetSubmenus',
  C021ImagenesPredeterminadas: 'SICPO/Catalogos/GetImagenesPredeterminadas',
  C001PaginaDeInicio:'SICPO/Catalogos/GetPaginasInicio',
  C013PaginasMicrositio:'SICPO/Catalogos/GetPaginasMicrositio',
  C014SeccionesMicrositios:'SICPO/Catalogos/GetSeccionesMicrositio',
  C004Menus: 'SICPO/Catalogos/GetMenus',
  C005TiposPosicion: 'SICPO/Catalogos/GetTiposPosicion',
  C024SeccionesDeIntranet: 'SICPO/Catalogos/GetSeccionesDeIntranet',
  C029PaginasDeIntranet: 'SICPO/Catalogos/GetPaginasDeIntranet',
  C030AreasDeIntranet: 'SICPO/Catalogos/GetAreasDeIntranet',
  C031TiposClinicasIntranet: 'SICPO/Catalogos/GetTiposDeClinicasIntranet',
  C025ContenidosDeIntranet: 'SICPO/Catalogos/GetTiposContenidosDeIntranet'
};
  
export default SICPO;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/catalogos/sicpo.js
// module id = null
// module chunks = 